import { ThemeProvider, CssBaseline } from "@mui/material";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { createAppTheme } from "./theme";
import { LanguageProvider, useLanguage } from "./contexts/languageContext";
import { LandingPage } from "./components/landing/landingPage";
import { AuthFlow } from "./components/auth/authFlow";
import "./App.css";
import { ToastProvider } from "./components/common/toast/toast.provider";

const AppContent = () => {
  const { currentLanguage } = useLanguage();

  const router = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/auth",
      element: <AuthFlow />,
    },
  ]);

  return (
    <ThemeProvider theme={createAppTheme(currentLanguage.dir)}>
      <CssBaseline />
      <ToastProvider />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};

export const App = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};
